<template>
  <div>
    <div class="maybeLike-goods" style="margin-top: 20px">
      <div class="maybeLike-goods-nav">
        <p
          v-for="(item, index) in ['猜你喜欢', '我的收藏', '最近浏览']"
          class="pointer"
          @click="maybeNavClick(index)"
          :class="currentBottomIndex == index ? 'active' : ''"
          :key="index"
        >
          {{ item }}
        </p>
      </div>
      <swiper
        ref="mySwiper"
        class="maybeLike-goods-list"
        :options="swiperOptions"
        v-if="goodsList.length"
      >
        <swiper-slide
          class="maybeLike-goods-item"
          v-for="(item, index) in goodsList"
          :key="index"
        >
          <div class="maybeLike-goods-item-inner">
            <a :href="('goodsDetail?goods_id=' + item.goods_id) | hrefFormat">
              <el-image
                :src="item.thumbnail"
                fit="cover"
                class="maybeLike-goods-picture"
              >
                <div slot="error" class="image-slot">
                  <el-image :src="'replaceImg.jpg' | imagePath"></el-image>
                </div>
              </el-image>
            </a>
            <a
              :href="('goodsDetail?goods_id=' + item.goods_id) | hrefFormat"
              class="maybeLike-goods-name"
            >
              {{ item.title }}
            </a>
            <div class="maybeLike-goods-item-footer">
              <div class="maybeLike-goods-price" v-if="item.price_type == 1">
                <strong><em>￥</em> {{ item.price | productPrice(priceFormatEnabled) }}</strong>
              </div>
              <div
                class="maybeLike-goods-price"
                v-else-if="item.price_type == 2"
              >
                <span
                  >活动价：<strong
                    ><em>￥</em> {{ item.prom_price | productPrice(priceFormatEnabled) }}</strong
                  ></span
                >
              </div>
              <div class="maybeLike-goods-price" v-else>
                <span
                  >协议价：<strong
                    ><em>￥</em> {{ item.agreement_price | productPrice(priceFormatEnabled) }}</strong
                  ></span
                >
                <span
                  >平台价：<del><em>￥</em>{{ item.price | productPrice(priceFormatEnabled) }}</del></span
                >
              </div>
              <img
                :src="'icon_car.png' | imagePath"
                class="pointer"
                @click="addToCar(item.goods_id)"
              />
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <cm-placeholder v-if="!goodsList.length"></cm-placeholder>
    </div>
    <!-- 加入购物车弹框 -->
    <CarUp
      :goods_id="selectGoodsId"
      :show="showCar"
      :price-format-enabled="priceFormatEnabled"
      @hide="showCar = false"
    ></CarUp>
  </div>
</template>

<script>
import CarUp from "@/components/CarUp";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  components: {
    Swiper,
    SwiperSlide,
    CarUp,
  },
  props: {
    priceFormatEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentBottomIndex: 0,
      goodsList: [],
      selectGoodsId: 0,
      showCar: false,
      swiperOptions: {
        slidesPerView: 5,
        speed: 500, //切换过渡速度
        autoplay: {
          delay: 600,
          disableOnInteraction: false,
        },
        observer: true, //
        observeParents: true, //
      },
    };
  },
  computed: {
    mySwiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  methods: {
    maybeNavClick(index) {
      if (!this.$.user.userToken()) {
        this.$message.warning("请先登录");
        return;
      }
      this.currentBottomIndex = index;
      if (index == 0) {
        this.getRecommendList();
      } else if (index == 1) {
        this.getCollectList();
      } else {
        this.getfootprint();
      }
    },
    // 猜你喜欢
    getRecommendList() {
      this.$.http
        .post("goods/recommendList", {
          page: 1,
        })
        .then((res) => {
          this.goodsList = res.data;
        });
    },
    // 我的收藏
    getCollectList() {
      this.$.http.post("goods/collect/list", { page: 1 }).then((res) => {
        this.goodsList = res.data;
      });
    },
    getfootprint() {
      var data = {
        page: 1,
      };
      this.$.http.post("goods/visit/list", data).then((res) => {
        this.goodsList = res.data;
      });
    },
    addToCar(goods_id) {
      this.showCar = true;
      this.selectGoodsId = goods_id;
    },
    resetMySwiper(e) {
      //根据分辨率大小动态设置swiper显示元素数量
      const { clientWidth } = document.documentElement;
      if (clientWidth >= 1400) {
        this.mySwiper.params.slidesPerView = 5;
      } else if (clientWidth >= 1200 && clientWidth < 1400) {
        this.mySwiper.params.slidesPerView = 4;
      } else if (clientWidth < 1200) {
        this.mySwiper.params.slidesPerView = 3;
      }
    },
  },
  mounted() {
    this.getRecommendList();
    window.addEventListener("resize", this.resetMySwiper);
  },
  destroyed() {
    window.removeEventListener("resize", this.setTriggerPos);
  },
  beforeCreate() {
    if (document.querySelector(".bodyCenter")) {
      document
        .querySelector(".bodyCenter")
        .setAttribute("style", "background:#ffffff;");
    }
  },
};
</script>

<style>
.maybeLike-goods {
  border: 1px solid #eeeeee;
  margin-bottom: 20px;
}
.maybeLike-goods-nav {
  background-color: #f5f5f5;
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #eee;
}
.maybeLike-goods-nav p {
  font-size: 16px;
  padding: 0 24px;
  line-height: 60px;
}
.maybeLike-goods-nav p.active {
  background-color: #e60012;
  color: #ffffff;
}
.maybeLike-goods-list {
  overflow: hidden;
}
.maybeLike-goods-item {
  border-right: 1px solid #eee;
}
.maybeLike-goods-item:last-child {
  border-right: none;
}
.maybeLike-goods-picture {
  display: flex;
  width: 200px;
  height: 200px;
  /* width: 235px;
      height: 235px; */
  /* height: 211px; */
  margin: auto;
  margin-top: 20px;
  border: 1px solid #eee;
}
.maybeLike-goods-name {
  display: block;
  font-size: 14px;
  color: #333333;
  margin: 20px 0;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 40px;
  text-align: left;
}
.maybeLike-goods-name:hover {
  color: #e60012;
}
.maybeLike-goods-price {
  font-size: 22px;
  color: #e60012;
}
.maybeLike-goods-price {
  flex-grow: 1;
  margin-right: 10px;
  text-align: left;
}
.maybeLike-goods-price span {
  color: #999999;
  font-size: 14px;
  display: flex;
  align-items: center;
}
.maybeLike-goods-price strong {
  color: #e60012;
  font-size: 22px;
}
.maybeLike-goods-price strong em {
  font-size: 16px;
}
.maybeLike-goods-item-footer {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.maybeLike-goods-item-footer img {
  width: 30px;
  height: 30px;
}
.maybeLike-goods-item-inner {
  padding: 10px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/MaybeLike/index.vue